import { NgModule } from '@angular/core';
import { ioteqMediaWatcherService } from '@tools/services/media-watcher/media-watcher.service';

@NgModule({
    providers: [
        ioteqMediaWatcherService
    ]
})
export class ioteqMediaWatcherModule
{
    /**
     * Constructor
     */
    constructor(private _ioteqMediaWatcherService: ioteqMediaWatcherService)
    {
    }
}
